import React from 'react';

import {PageWrapperLayout} from 'presentation/components';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {MakeUfSelection} from 'main/factories/pages';

const {healthGuideAll} = translations['pt-br'].privateFlow.services;

export function HealthGuideStates() {
	return (
		<PageWrapperLayout title={healthGuideAll}>
			<MakeUfSelection flowType={FlowEnum.HEALTH_GUIDE} />
		</PageWrapperLayout>
	);
}
